import axios from "axios"
import { useFormik } from "formik"
import React from "react"
import { Button, FloatingLabel, Form } from "react-bootstrap"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import * as Yup from "yup"
import logo from "../../assets/images/logo.svg"
import { admin } from "../../config/apiEndpoints"

const ForgotPassword = () => {
  const validationSchema = Yup.object({
    email: Yup.string()
      .required("Email is Required")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Please enter a valid email"
      ),
  })

  const handleSubmit = async (values) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}${admin.forgotPassword}`,
        values
      )
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message)
      } else {
        toast.error(response?.data?.message)
      }
    } catch (error) {
      toast.error("Something went wrong")
    }
  }

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  })

  const { errors, values, touched, setFieldValue, setFieldTouched } = formik

  return (
    <div className="position-relative">
      <div className="login_screen_vh">
        <div className="login_bg d-flex align-items-center justify-content-center">
          <div className="login_screen shadow-sm">
            <img src={logo} alt="MegaCharge" className="logo_login mb-3" />
            <h1 className="fs-4 mb-4">Forgot Password</h1>
            <Form noValidate onSubmit={formik.handleSubmit}>
              <FloatingLabel
                controlId="floatingInput"
                className="mb-3"
                label={
                  <>
                    Email Address <span className="required_star">*</span>
                  </>
                }
              >
                <Form.Control
                  autoComplete="false"
                  type="email"
                  name="email"
                  placeholder=""
                  className="bg-white mb-n1"
                  value={values.email}
                  onChange={(e) => {
                    setFieldTouched("email", true)
                    setFieldValue("email", e?.target?.value)
                  }}
                  isInvalid={touched.email && errors.email}
                  isValid={touched.email && !errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </FloatingLabel>

              <div className="d-flex justify-content-end align-items-center mb-3">
                <Link
                  className="link-secondary link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover"
                  to="/login"
                >
                  Back to Login
                </Link>
              </div>

              <Button variant="primary" type="submit" className="w-100">
                Send Email
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
